import { Link } from "react-router-dom";
import SectionHeader from "@/components/feature/SectionHeader";
import { articles } from "@/mocks/articles";

const features = [
  { icon: "ri-gallery-fill", title: "分类清晰", desc: "异世界、精灵、妖怪三大世界观分区，快速定位你爱的题材。" },
  { icon: "ri-sparkling-fill", title: "简介对味", desc: "剧情简介不剧透又吊胃口，帮你高效判断是否入坑。" },
  { icon: "ri-refresh-line", title: "更新速览", desc: "热门作品连载动态与题材解析，每周持续更新。" },
  { icon: "ri-book-3-line", title: "专题深入", desc: "题材解析与选漫指南，让追漫更懂行。" },
];

export default function ArticlesAndAbout() {
  return (
    <section className="py-14 md:py-20">
      <div className="container-site">
        <SectionHeader
          eyebrow="专题精选"
          title="不只是追更，更懂这部作品"
          subtitle="选漫指南、题材解析与更新速递，帮你把每一部妖精漫画看得明明白白。"
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {articles.map((a) => (
            <Link key={a.id} to="/about" className="group card flex flex-col overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-primary-300">
              <div className="relative h-40 w-full overflow-hidden bg-background-100">
                <img src={a.image} alt={`${a.title} 专题文章配图`} loading="lazy" className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                <span className="absolute left-2.5 top-2.5 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-primary-700">{a.category}</span>
              </div>
              <div className="flex flex-1 flex-col gap-2 p-4">
                <h3 className="line-clamp-2 text-sm font-semibold leading-snug text-foreground-900 group-hover:text-primary-700">{a.title}</h3>
                <p className="line-clamp-2 text-xs leading-relaxed text-foreground-500">{a.excerpt}</p>
                <div className="mt-auto flex items-center gap-2 pt-1 text-xs text-foreground-400">
                  <span>{a.date}</span>
                  <span className="flex items-center gap-0.5"><i className="ri-time-line" />{a.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-14 rounded-lg border border-primary-200 bg-primary-50 p-7 md:p-9">
          <div className="grid items-center gap-6 lg:grid-cols-[1.1fr_2fr]">
            <div>
              <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-primary-700">
                <i className="ri-sparkling-2-fill" />
                关于妖精漫画堂
              </span>
              <h3 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">为幻想爱好者打造的一站式选漫之地</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                我们专注韩国妖精漫画的奇幻魔法、异世界穿越、精灵契约与妖怪神话题材，坚持「分类清晰、简介对味、尊重原创」的内容原则，把真正值得一读的奇幻世界送到你眼前。
              </p>
              <Link to="/about" className="btn btn-primary mt-5">
                了解更多
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {features.map((f) => (
                <div key={f.title} className="rounded-lg bg-background-50 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className={`${f.icon} text-lg`} />
                  </span>
                  <h4 className="mt-3 text-sm font-semibold text-foreground-900">{f.title}</h4>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}